import { render, staticRenderFns } from "./liftManagementInfo.vue?vue&type=template&id=6015cb0a&"
import script from "./liftManagementInfo.vue?vue&type=script&lang=js&"
export * from "./liftManagementInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports